type Item = { label: string; value: string };

interface TldrBoxProps {
  title?: string;
  items: Item[];
  summary?: string;
}

/**
 * Bloc "En résumé" optimisé AIO / GEO.
 * Affiche un récapitulatif citatif court (Perplexity, Google AI Overviews, ChatGPT Search).
 * Le markup utilise <dl> + class "speakable-tldr" pour permettre l'extraction.
 */
export function TldrBox({ title = "En résumé", items, summary }: TldrBoxProps) {
  return (
    <aside
      aria-label={title}
      className="speakable-tldr max-w-3xl mx-auto my-12 border border-[var(--gold-line)] bg-card/60 backdrop-blur p-6 sm:p-8"
    >
      <p className="eyebrow text-[var(--gold)] mb-4">{title}</p>
      {summary && (
        <p className="text-sm sm:text-base text-foreground/90 font-light leading-relaxed mb-5">
          {summary}
        </p>
      )}
      <dl className="grid sm:grid-cols-2 gap-x-8 gap-y-3 text-sm">
        {items.map((it) => (
          <div key={it.label} className="flex flex-col border-l-2 border-[var(--gold)]/40 pl-3">
            <dt className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              {it.label}
            </dt>
            <dd className="text-foreground/90 font-light mt-0.5">{it.value}</dd>
          </div>
        ))}
      </dl>
    </aside>
  );
}
